import axios, {AxiosRequestConfig} from 'axios';

axios.interceptors.request.use(req => {
    const token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = token;
    }
    return req;
});